/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./drawerLogo.vue?vue&type=template&id=41c6bc5e&"
import script from "./drawerLogo.vue?vue&type=script&lang=js&"
export * from "./drawerLogo.vue?vue&type=script&lang=js&"
import style0 from "./drawerLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem})
